module.exports = __webpack_public_path__ + "static/media/menuHandlerOpen.19303f01.svg";